export enum FileType {
  DOC = "doc",
  DOCX = "docx",
  ZIP = "zip",
  PDF = "pdf",
  EXCEL = "excel",
  PNG = "png"
}
export type CommonForm = {
  PageFiles?: File[];
  BranchCompanyFlowId?: string | number;
  PageData?: {
    [key: string]: any;
  };
  IsSupplement?: boolean;
};

export type Recall = {
  BusinessFlowId: number;
  WorkFlowId?: number;
  Reason: string;
};

export type WorkflowItem = {
  StaffName: string;
  PositionName: string;
  PhotoUrl: string;
  Status: number;
  ApproveTime: string;
  Description: string;
  Remark: string;
};

export type Workflow = {
  ApproveType: number;
  Level?: string;
  StaffType: number;
  Status: string;
  DetailList?: WorkflowItem[];
  IsCurrent?: number;
};

export type File = {
  FileName: string;
  FileUrl: string;
  AccessoryType: number;
  Sort?: number;
  Url?: string;
};
export type Detail = {
  BranchCompanyFlowId?: number;
  PageFiles?: File[];
  ActionButtons?: string[];
  WorkFlowId?: number;
  IsEdit?: boolean;
  PageData?: {
    // GsReviewBusRegisterName?: string;
    // YhDocumentCollection?: string;
    // YhBankName?: string;
    // YhCompanyEntity?: string;
    // AccountName?: string;
    // BankName?: string;
    // AccountNumber?: string;
    // OpeningDate?: string;
    // AccountManagerName?: string;
    // AccountManagerPhone?: string;
    // DepositAccountNumber?: string;
    [key: string]: any;
  };
};
export type NodeItem = {
  Id?: number;
  Code?: string;
  Title?: string;
  ParentCode?: number|string;
  Level?: number;
  State?: number;
  IsOperation?: boolean;
  PreConditionCode: string;
  IsBackhaul?: boolean;
  Sort?: boolean;
  BranchCompanyFlowId: number;
  StaffId?: number;
  StaffName?: string;
  IsAnchorPoint?: boolean;
  ChildAnchorPointCode?: string;
  IsShow?:boolean;
};
